<script>
//import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';

export default {
  components: {
    //ChevronLeft   
  },
  data() {
    return {
      event_id:this.$route.params.id??0,
    }
  },
  watch: {
    '$route' (to,from ) {
      to;from;
      this.event_id=this.$route.params.id??0;
    }
  }
}
</script>
<style>
.my-nav.nav li.nav-item.border-bottom{border-bottom:1px dotted #666;}
.my-nav.nav li.nav-item a.nav-link{color: #ccc;}
</style>
<template>
  <nav id="MyNavbar" class="flex-column collapse d-md-block d-lg-block">
    <ul class="nav nav-pills flex-column mb-3  my-nav">
      <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'Home'}"><big class="btn btn-dark"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg></big></RouterLink></li>
    </ul>
    <ul v-if="!event_id" class=" nav nav-pills flex-column mb-3 p-3 my-nav">
        <li class="border-bottom nav-item"><a disabled="true" class="text-white nav-link  active">Genel Bilgiler</a></li>
        <li class="border-bottom nav-item"><a disabled="true" class="text-white nav-link">Detaylar</a></li>
        <li class="border-bottom nav-item"><a disabled="true" class="text-white nav-link">Linkler</a></li>
        <li class="border-bottom nav-item"><a disabled="true" class="text-white nav-link">Görseller</a></li>
        <li class="border-bottom nav-item"><a disabled="true" class="text-white nav-link">Onay</a></li>
    </ul> 
    <ul v-else class=" nav nav-pills flex-column mb-3 p-3 my-nav">
        <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'eventUpdateGeneralForm',params:{id:this.event_id}}">Genel Bilgiler</RouterLink></li>
        <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'eventUpdateDetailForm',params:{id:event_id}}">Detaylar</RouterLink></li>
        <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'eventUpdateLinksForm',params:{id:event_id}}">Linkler</RouterLink></li>
        <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'eventUpdateImagesForm',params:{id:event_id}}">Görseller</RouterLink></li>
        <li class="border-bottom nav-item"><RouterLink class="text-white nav-link" :to="{ name: 'eventUpdateConfirmForm',params:{id:event_id}}">Onay</RouterLink></li>
    </ul>    
  </nav>
</template>